<template>
    <div>
        <div v-if="isMobile" class="d-flex align-items-center p-2 bg-light shadow-sm sticky-top">
          <b-button variant="link" class="p-0 mr-2" @click="drawerOpen = true">
            <b-icon-list></b-icon-list>
          </b-button>
          <span class="font-weight-bold">{{ activeTabTitle }}</span>
        </div>

        <b-sidebar
          id="mobile-drawer"
          title="Process Deliveries"
          shadow
          bg-variant="light"
          text-variant="dark"
          :visible="drawerOpen"
          @hidden="drawerOpen = false"
          backdrop
          placement="left"
        >
          <hr/>
          <ul class="list-unstyled m-0">
            <li v-for="(tab, index) in filteredTabs" :key="index" class="mb-2">
              <b-button
                block
                squared
                :variant="activeTabIndex === index ? null : 'link'"
                class="text-left"
                @click="selectTab(index)"
              >
                <b-icon :icon="tab.icon" class="mr-2"></b-icon>
                {{ tab.title }}
              </b-button>
            </li>
          </ul>
        </b-sidebar>
        <div v-if="!isMobile">
          <b-tabs card lazy content-class="mt-1">
            <!-- <b-tab title="SHIPPING/RECEIVING" v-if="['admin', 'locationadmin', 'locationuser', 'officeuser', 'warehouseuser', 'warehousemanager'].includes(packet.userDetails.userrole.toLowerCase())">
                <IncomingOutgoing />
            </b-tab>
 -->

            <b-tab
                v-if="[
                    'admin',
                    'officeuser',
                    'officemanager',
                    'locationadmin',
                    'locationstockperson',
                    'warehouseuser',
                    'warehousemanager'
                ].includes(packet.userDetails.userrole)"
            >
                <template #title>
                    <b-icon-box class="mr-1"></b-icon-box>
                    WH PULLIST
                </template>
                <ItemsToPull />
            </b-tab>

            <b-tab
                v-if="[
                    'admin',
                    'officeuser',
                    'officemanager',
                    //'locationadmin',
                    //'locationstockperson',
                    //'warehouseuser',
                    //'warehousemanager',
                    'housetruck'
                ].includes(packet.userDetails.userrole)"
            >
                <template #title>
                    <b-icon-truck class="mr-1"></b-icon-truck>
                    WH TRANSFER
                </template>
                <ItemsToPick />
            </b-tab>


            <b-tab v-if= "['admin',
                    'officeuser',
                    'officemanager',
                    'locationadmin',
                    'locationstockperson',
                    'warehouseuser',
                    'warehousemanager'].includes(packet.userDetails.userrole)">
                <template #title>
                    <b-icon-arrow-down-circle class="mr-1"></b-icon-arrow-down-circle>
                    RECEIVING
                </template>
                <MeccaReceiving />
            </b-tab>

            <b-tab v-if= "['admin',
                    'officeuser',
                    'officemanager',
                    'locationadmin',
                    'locationstockperson',
                    'warehouseuser',
                    'warehousemanager'].includes(packet.userDetails.userrole)">
                <template #title>
                    <b-icon-arrow-up-circle class="mr-1"></b-icon-arrow-up-circle>
                    TRANSFER SHIPPING
                </template>
                <shipping />
            </b-tab>

            <b-tab
                 v-if="[
                    'admin',
                    'officeuser',
                    'officemanager',
                    // 'locationadmin',
                    // 'locationstockperson',
                    // 'warehouseuser',
                    // 'warehousemanager'
                     'housetruck',
                ].includes(packet.userDetails.userrole)"
            >
                <template #title>
                    <b-icon-truck class="mr-1"></b-icon-truck>
                    STORE TRANSFER
                </template>
                <StoreTransfer />
            </b-tab>

            <b-tab
                 v-if="[
                    'admin',
                    'officeuser',
                    'officemanager',
                    'locationadmin',
                    'locationstockperson',
                    'warehouseuser',
                    'warehousemanager'
                ].includes(packet.userDetails.userrole)"
            >
                <template #title>
                    <b-icon-check-circle class="mr-1"></b-icon-check-circle>
                    STORE RECEIVING
                </template>
                <StoreReceiving />
            </b-tab>
             <b-tab
                 v-if="[
                    'admin',
                    'officeuser',
                    'officemanager',
                    'locationadmin',
                    'locationstockperson',
                    'warehouseuser',
                    'warehousemanager'
                ].includes(packet.userDetails.userrole)"
            >
                <template #title>
                    <b-icon-check-circle class="mr-1"></b-icon-check-circle>
                    STORE READY TO SHIP
                </template>
                <StoreReadyToShip />
            </b-tab>

            <!-- <b-tab
                 v-if="[
                    'admin',
                    'officeuser',
                    'officemanager',
                ].includes(packet.userDetails.userrole)"
            >
                <template #title>
                    <b-icon-clipboard class="mr-1"></b-icon-clipboard>
                    LOAD DVLRS
                </template>
                <DeliveriesLoading2 />
            </b-tab> -->

            <b-tab
                v-if="[
                    'admin',
                    'accountmanager',
                    'officeuser',
                    'officemanager',
                    'locationadmin',
                    'salesperson',
                ].includes(packet.userDetails.userrole)"
            >
                <template #title>
                    <b-icon-list-check class="mr-1"></b-icon-list-check>
                    DLVRY LISTS
                </template>
                <DeliveriesShipping />
            </b-tab>

            <b-tab
                v-if="[
                    'admin',
                    'accountmanager',
                    'officeuser',
                    'officemanager',
                    'locationadmin',
                    'salesperson',
                    'warehouseuser',
                    'warehousemanager',
                    'housetruck'
                ].includes(packet.userDetails.userrole)"
            >
                <template #title>
                    <b-icon-exclamation-triangle class="mr-1"></b-icon-exclamation-triangle>
                    DISCREP
                </template>
                <AdminToolsDiscrepancies />
            </b-tab>

            <!-- <b-tab
                 v-if="[
                    'admin',
                    'officeuser',
                    'officemanager',
                    'locationadmin',
                    'locationstockperson',
                    'warehouseuser',
                    'warehousemanager'
                ].includes(packet.userDetails.userrole)"
            >
                <template #title>
                    <b-icon-clipboard-check class="mr-1"></b-icon-clipboard-check>
                    ORDER STATUS
                </template>
                <OrderShipment />
            </b-tab> -->

            <b-tab
                v-if="[
                    'admin',
                    'accountmanager',
                    'officeuser',
                    'officemanager',
                    //'locationadmin',
                    //'salesperson',
                    //'warehouseuser',
                    //'warehousemanager'
                ].includes(packet.userDetails.userrole)"
            >
                <template #title>
                    <b-icon-search class="mr-1"></b-icon-search>
                    TRACK ORDER
                </template>
                <AdminToolsTrackInvoice />
            </b-tab>

            <!-- Additional tabs with icons if you uncomment them -->
            <!-- <b-tab
                v-if="[
                    'admin',
                    'accountmanager',
                    'officeuser',
                    'officemanager',
                    'locationadmin',
                    'salesperson',
                    'warehouseuser',
                    'warehousemanager'
                ].includes(packet.userDetails.userrole)"
            >
                <template #title>
                    <b-icon-box-seam class="mr-1"></b-icon-box-seam>
                    CONTAINER ORDERS
                </template>
                <ContainerOrders />
            </b-tab>

            <b-tab
                v-if="[
                    'admin',
                    'accountmanager',
                    'officeuser',
                    'officemanager',
                    'locationadmin',
                    'salesperson',
                    'warehouseuser',
                    'warehousemanager'
                ].includes(packet.userDetails.userrole)"
            >
                <template #title>
                    <b-icon-house class="mr-1"></b-icon-house>
                    DOMESTIC ORDERS
                </template>
                <StockOrders />
            </b-tab> -->
        </b-tabs>
        </div>

        <div class="d-md-none mt-2">
          <component :is="activeTabComponent"></component>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import Requestor from '@/utilities/Requestor';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    // Import BootstrapVue icons
    import {
        BIconTruck,
        BIconBox,
        BIconArrowDownCircle,
        BIconArrowUpCircle,
        BIconCheckCircle,
        BIconClipboard,
        BIconListCheck,
        BIconExclamationTriangle,
        BIconClipboardCheck,
        BIconSearch,
        BIconBoxSeam,
        BIconHouse
    } from 'bootstrap-vue';

    import ItemComments from '@/components/importables/ItemComments'

    import Incoming from '@/components/IncomingOutGoing/Incoming'
    import Outgoing from '@/components/IncomingOutGoing/Outgoing'

    import IncomingOutgoing from '@/components/IncomingOutGoing/IncomingOutgoing'

    import ItemsToPull from '@/components/IncomingOutGoing/ItemsToPull'

    import ItemsToPick from '@/components/IncomingOutGoing/ItemsToPick'

    import DeliveriesLoading2 from '@/components/IncomingOutGoing/DeliveriesLoading2'

    import DeliveriesShipping from '@/components/IncomingOutGoing/DeliveriesShipping'

    import AdminToolsDiscrepancies from '@/components/AdminTools/AdminToolsDiscrepancies'

    import AdminToolsTrackInvoice from '@/components/AdminTools/AdminToolsTrackInvoice'

    import AdminToolsDeliveredOrders from '@/components/AdminTools/AdminToolsDeliveredOrders'

    import OrderShipment from '@/components/IncomingOutGoing/OrderShipment'

    import ContainerOrders from '@/components/IncomingOutGoing/ContainerOrders'

    import StockOrders from '@/components/IncomingOutGoing/StockOrders'

    import StoreReceiving from '@/components/IncomingOutGoing/StoreReceiving.vue'

    import MeccaReceiving from '@/components/IncomingOutGoing/MeccaReceiving.vue'

    import Shipping from '@/components/IncomingOutGoing/Shipping.vue'

    import StoreReadyToShip from '@/components/IncomingOutGoing/StoreReadyToShip.vue'

    import StoreTransfer from '@/components/IncomingOutGoing/StoreTransfer.vue'


    export default {
        name: "ShippingReceivingMain",
        components: {
            flatPickr,
            Loading,
            Shipping,
            StoreTransfer,
            MeccaReceiving,
            StoreReceiving,
            ItemComments,
            IncomingOutgoing,
            ItemsToPull,
            ItemsToPick,
            StoreReadyToShip,
            DeliveriesLoading2,
            DeliveriesShipping,
            AdminToolsDiscrepancies,
            AdminToolsTrackInvoice,
            AdminToolsDeliveredOrders,
            Incoming,
            Outgoing,
            OrderShipment,
            ContainerOrders,
            StockOrders,
            // BootstrapVue Icons
            BIconTruck,
            BIconBox,
            BIconArrowDownCircle,
            BIconArrowUpCircle,
            BIconCheckCircle,
            BIconClipboard,
            BIconListCheck,
            BIconExclamationTriangle,
            BIconClipboardCheck,
            BIconSearch,
            BIconBoxSeam,
            BIconHouse
        },
        data: function(){
            return {
                drawerOpen: false,
                activeTabIndex: 0,
                isMobile: false,
                tabs: [
                    { title: 'WH PULLIST', icon: 'box', roles: ['admin','officeuser','officemanager','locationadmin','locationstockperson','warehouseuser','warehousemanager'], component: 'ItemsToPull' },
                    { title: 'WH TRANSFER', icon: 'truck', roles: ['admin','officeuser','officemanager','housetruck'], component: 'ItemsToPick' },
                    { title: 'RECEIVING', icon: 'arrow-down-circle', roles: ['admin','officeuser','officemanager','locationadmin','locationstockperson','warehouseuser','warehousemanager'], component: 'MeccaReceiving' },
                    { title: 'TRANSFER SHIPPING', icon: 'arrow-up-circle', roles: ['admin','officeuser','officemanager','locationadmin','locationstockperson','warehouseuser','warehousemanager'], component: 'Shipping' },
                    { title: 'STORE TRANSFER', icon: 'truck', roles: ['admin','officeuser','officemanager','housetruck'], component: 'StoreTransfer' },
                    { title: 'STORE RECEIVING', icon: 'check-circle', roles: ['admin','officeuser','officemanager','locationadmin','locationstockperson','warehouseuser','warehousemanager'], component: 'StoreReceiving' },
                    { title: 'LOAD DVLRS', icon: 'clipboard', roles: ['admin','officeuser','officemanager'], component: 'DeliveriesLoading2' },
                    { title: 'DLVRY LISTS', icon: 'list-check', roles: ['admin','accountmanager','officeuser','officemanager','locationadmin','salesperson'], component: 'DeliveriesShipping' },
                    { title: 'DISCREP', icon: 'exclamation-triangle', roles: ['admin','accountmanager','officeuser','officemanager','locationadmin','salesperson','warehouseuser','warehousemanager','housetruck'], component: 'AdminToolsDiscrepancies' },
                    { title: 'ORDER STATUS', icon: 'clipboard-check', roles: ['admin','officeuser','officemanager','locationadmin','locationstockperson','warehouseuser','warehousemanager'], component: 'OrderShipment' },
                    { title: 'TRACK ORDER', icon: 'search', roles: ['admin','accountmanager','officeuser','officemanager'], component: 'AdminToolsTrackInvoice' },
                ],
                packet: {
                    userDetails: {
                        userrole: '',
                        properties: {} // Initialize with empty properties
                    }
                }
            }
        },
        computed: {
            filteredTabs() {
              const role = this.packet.userDetails.userrole || '';
              return this.tabs.filter(tab => tab.roles.includes(role));
            },
            activeTabTitle() {
              const tab = this.filteredTabs[this.activeTabIndex];
              return tab ? tab.title : 'Menu';
            },
            activeTabComponent() {
              const tab = this.filteredTabs[this.activeTabIndex];
              return tab ? tab.component : null;
            },
            showMeccaReceivingTab() {
                // Safe access to user details
                if (!this.packet || !this.packet.userDetails) {
                    return false;
                }

                const userRole = this.packet.userDetails.userrole;

                // If user is admin, show based on original role criteria
                if (userRole === 'admin') {
                    return true;
                }

                // Safe access to location_id
                const userProperties = this.packet.userDetails.properties || {};
                const userLocationId = userProperties.location_id || this.packet.userDetails.location_id;

                // If user is not admin, only show if location ID is 47 (Mecca shipping)
                return userLocationId === 47;
            }
        },
        methods: {
            selectTab(index) {
              if (index < 0) index = 0;
              if (index >= this.filteredTabs.length) index = this.filteredTabs.length - 1;
              this.activeTabIndex = index;
              this.drawerOpen = false;
            },
            handleResize() {
              this.isMobile = window.innerWidth < 768;
            },
            // Add a method to safely initialize user details
            initializeUserDetails() {
                try {
                    const packetData = localStorage.getItem('packet');
                    const userDetailsData = localStorage.getItem('userDetails');

                    if (packetData) {
                        this.packet = JSON.parse(packetData);
                    }

                    if (userDetailsData) {
                        const userDetails = JSON.parse(userDetailsData);
                        this.packet.userDetails = userDetails;

                        // Ensure properties exists
                        if (!this.packet.userDetails.properties) {
                            this.packet.userDetails.properties = {};
                        }
                    }
                } catch (error) {
                    console.error('Error initializing user details:', error);
                }
            }
        },
        mounted() {
          this.handleResize();
          window.addEventListener('resize', this.handleResize);
        },
        beforeDestroy() {
          window.removeEventListener('resize', this.handleResize);
        },
        created: function(){
            this.initializeUserDetails();
            let that = this;
        }
    }
</script>

<style scoped>
    .ipt_tdr {
        font-family: roboto !important;
        font-size: 13px;
        background: white;
    }

    .pcol {
        padding: 5px;
    }

    .card-body {
        padding: 5px;
    }

    /* Optional: Add some styling to make icons consistent */
    .b-tabs ::v-deep .nav-link {
        display: flex;
        align-items: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/IncomingOutGoing/ShippingReceivingMain.vue